import React, {useState} from 'react';
import ModalForm from '../Modals/ModalForm';

import { IconButton, Tooltip } from '@material-ui/core';
import { AddBox as AddBoxIcon } from '@material-ui/icons';

const Toolbar = (props) => {

    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <>
            <IconButton aria-label="upload-book" onClick={handleClick}>
                <Tooltip title="Upload Book">
                    <AddBoxIcon />
                </Tooltip>
            </IconButton>

            <ModalForm
                dialogTitle={'Upload E-book'}
                open={open}
                handleClose={handleClose}
                fetchEbooks={props.fetchEbooks}
            />
        </>
    );
}

export default Toolbar;